/**
 * Setting key (a SettingKey enum member NAME) that carries whether the mobile app may send telemetry to
 * Application Insights for the signed-in branch. Read from the branch-scoped settings map in
 * {@link ApplicationContextStore}; the string value is 'true'/'false'. The server always sends the resolved
 * value (default 'true'), so a missing key means the settings have not loaded yet and telemetry stays off.
 */
export const MOBILE_TELEMETRY_SETTING_KEY = 'MobileTelemetryEnabled';

/**
 * Setting key (a SettingKey enum member NAME) that carries whether the web app may send telemetry to Application
 * Insights for a staff user's signed-in branch. Read the same way as {@link MOBILE_TELEMETRY_SETTING_KEY}. Customer
 * sessions opened from a link cannot read branch settings, so this key does not govern them.
 */
export const WEB_TELEMETRY_SETTING_KEY = 'WebTelemetryEnabled';
